import _ from 'lodash';

const SendMailData = ({
  location,
  title,
  firstname,
  lastname,
  email,
  telephone,
  country,
  interested,
  propertytype,
  message,
  subscribe,
  source,
  websiteKey,
  sourceUrl,
  language,
  recaptcha,
  emailSetting,
}) => {
  const values = {
    location,
    title,
    firstname,
    lastname,
    email,
    telephone,
    country,
    interested,
    propertytype,
    message,
    subscribe,
    source,
    websiteKey,
    sourceUrl,
    language,
    'g-recaptcha-response': recaptcha,
    emailSetting,
  };
  const url = `${process.env.SERVICE_HOST}/enquiry/submit`;
  console.log(values, url);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      ...values,
      // subject: 'Property Exhibition Registration Form – Skypark Phuket',
      // to: 'dos@lagunaproperty.com',
      // cc: 'info@lagunaproperty.com,pemisak@lagunaproperty.com,vatanyutab@lagunaproperty.com',
    }),
  }).then(res => {
    return res.json();
  }).then(res => {
    console.log({ res });
    return res;
  });
};

export default SendMailData;



// WEBPACK FOOTER //
// ./src/components/SendMailData/index.js